export default __webpack_public_path__ + "static/media/640_private01-en-mobile.8053fb64.png";